import React, { createContext, useContext, useState } from "react";

const BillContext = createContext();

export function BillProvider({ children }) {
  const [billData, setBillData] = useState(null); // { kwh, savings }

  return (
    <BillContext.Provider value={{ billData, setBillData }}>
      {children}
    </BillContext.Provider>
  );
}

export const useBill = () => useContext(BillContext);
